export default __webpack_public_path__ + "static/brcc-hero-right-b80ab9be7104277db9f972a261faa301.webp";